import { useTranslation } from "react-i18next";
import { getImage } from "../../services/ImageService.js";
import { CustomerQuote } from "../../components/CustomerQuote/CustomerQuote.js";
import { SectionCard } from "../../components/SectionCard/SectionCard.js";
import { SectionCardHeader } from "../../components/SectionCard/SectionCardHeader.js";
import { SectionCardHStack } from "../../components/SectionCard/SectionCardHStack.js";
import { SectionCardGrid } from "../../components/SectionCard/SectionCardGrid.js";
import { SectionCardVStack } from "../../components/SectionCard/SectionCardVStack.js";
import { SectionCardSubsection } from "../../components/SectionCard/SectionCardSubsection.js";
import { NavigationActionButton } from "../../components/NavigationActionButton/NavigationActionButton.js";

export function ForestManagementSection() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-24">
            <SectionCard
                id="forest-management"
                img="cards/forest-cropped.png"
                className="bg-earth"
                gradientClassName="earth-gradient"
            >
                <SectionCardHeader
                    title={t("home-forest-management-card-title")}
                    text={t("home-forest-management-card-text")}
                />
                <SectionCardGrid className="grid-cols-3">
                    <SectionCardHStack
                        img="cards/swamp-cropped.png"
                        title={t("home-forest-management-card-section-1-title")}
                        text={t("home-forest-management-card-section-1-text")}
                    />
                    <SectionCardVStack
                        title={t("home-forest-management-card-section-2-title")}
                        text={t("home-forest-management-card-section-2-text")}
                    />
                    <SectionCardVStack
                        title={t("home-forest-management-card-section-3-title")}
                        text={t("home-forest-management-card-section-3-text")}
                    />
                    <SectionCardVStack
                        title={t("home-forest-management-card-section-4-title")}
                        text={t("home-forest-management-card-section-4-text")}
                    />
                </SectionCardGrid>
                <CustomerQuote
                    img={getImage("quotes/elin.png")}
                    className="bg-darkEarth"
                    quote={t("home-forest-management-customer-2")}
                    customer="Elin Andersson, JGA Skog"
                />
                <CustomerQuote
                    img={getImage("quotes/mats.png")}
                    className="bg-darkEarth"
                    quote={t("home-forest-management-customer-1")}
                    customer="Mats Warensjö, Skogssällskapet"
                />
                <SectionCardSubsection className="bg-darkEarth">
                    <img
                        className="w-48 h-48 mb-8 lg:mr-16 lg:mb-0"
                        src={getImage("logos/skogssallskapet-circle.png")}
                        alt="Skogssällskapet"
                        loading="lazy"
                    />
                    <div className="text-base gap-4 flex flex-col font-regular">
                        <div>
                            <div className="text-xl mt-0 font-semibold font-robotoCondensed">
                                {t("sfab-forest-management-planning-title")}
                            </div>
                            <p>{t("sfab-forest-management-planning-text")}</p>
                        </div>
                        <NavigationActionButton
                            className="my-0 !text-black !bg-white hover:!bg-[rgba(255,255,255,0.9)] w-full sm:w-min"
                            label={t("learn-more")}
                            href="/sfab-forest-management-planning"
                        />
                    </div>
                </SectionCardSubsection>
            </SectionCard>
            <SectionCard
                id="planning-drone-praxis"
                className="bg-earth !gap-12"
                img="cards/planning-drone-praxis-cropped.png"
                gradientClassName="earth-gradient"
            >
                <SectionCardVStack
                    title={t("home-planning-drone-praxis-card-title")}
                    text={t("home-planning-drone-praxis-card-text")}
                    className="mr-0 sm:mr-32 lg:mr-[36rem]"
                >
                    <NavigationActionButton
                        className="my-0 !text-black !bg-white hover:!bg-[rgba(255,255,255,0.9)] w-full sm:w-min"
                        label={t("learn-more")}
                        href="/planning-drone-praxis"
                    />
                </SectionCardVStack>
            </SectionCard>
        </div>
    );
}
